var map = {
	"./_MG_2879.jpg": 45785,
	"./_MG_2886.jpg": 58508,
	"./_MG_2889.jpg": 45741,
	"./_MG_2903.jpg": 21425,
	"./_MG_2907.jpg": 99230,
	"./_MG_2927.jpg": 63501,
	"./_MG_2941.jpg": 41292,
	"./_MG_2958.jpg": 96975,
	"./_MG_3023.jpg": 12402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71364;